import React from "react";
import Footer from "../../components/modules/Footer";
import Navbar from "../../components/modules/Navbar";
import './GalerieStyles.css'
import Pics from '../../assets/asso_partenaire/pics.png'
import './../EngagementsStyles.css'
import { useTranslation } from "react-i18next";

const Galerie = () => {
    const { t } = useTranslation('common');

    return (
        <div>
            <Navbar />
            <div className="galerie">
                <h1> {t('galeries_photos.galerie photo')}</h1>
                <div className="galerie-pics">
                    <h3> {t('galeries_photos.texte_galerie')} </h3>
                    <a href='https://galerie.pics/'><img src={Pics} alt="Pics galerie" /></a>
                    <h3>
                        {t('galeries_photos.encoremerci')}
                    </h3>
                    <div className="galerie-links">
                        <a href="https://galerie.pics/galerie/toss-2024-2025"> Edition 2025</a>
                        <a href="https://galerie.pics/galerie/toss-2024"> Edition 2024</a>
                        <a href="https://galerie.pics/galerie/toss-2022-2023"> Edition 2023</a>
                        <a href="https://galerie.pics/galerie/toss-2022"> Edition 2022</a>
                        <a href="https://galerie.pics/galerie/toss-2019"> Edition 2019</a>
                        <a href="https://galerie.pics/galerie/toss-2018"> Edition 2018</a>
                    </div>

                </div>
            </div>
            <Footer />
        </div>
    )


}

export default Galerie